module.exports = __webpack_public_path__ + "static/media/45D54ADC-7364-4488-B657-D5F787E3FD72.2ff83978.JPG";